import Countly from "countly-sdk-web";

const appKey = process.env.REACT_APP_COUNTLY_APP_KEY;
const appUrl = process.env.REACT_APP_COUNTLY_URL;
const appId = process.env.REACT_APP_COUNTLY_API_KEY;

if (appKey && appUrl) {
    Countly.init({
        app_key: appKey,
        url: appUrl,
        debug: false, // mode !== "PROD",
    });
    Countly.track_sessions();
    Countly.track_errors();
    Countly.track_pageview(undefined, null, localStorage.getItem("pid") ? { pid: localStorage.getItem("pid") } : undefined);
    Countly.user_details({
        custom: {
            // app_id: appId,
            pid:  localStorage.getItem("pid") ? localStorage.getItem("pid") : null,
        },
    });
}
const countly = {
    pageView(pageName, segments) {
        if (appKey) Countly.track_pageview(pageName, null, segments);
    },

    event(key, segmentation) {
        if (appKey) Countly.add_event({ key, segmentation });
    },

    setUser(userData) {
        if (!appKey) return;
        Countly.change_id(String(userData.userId));
        if (userData.pid) {
            Countly.userData.set("pid", String(userData.pid));
        }
        Countly.userData.save();
    },

    setUserProperty(key, value) {
        if (!appKey) return;
        Countly.userData.set(key, String(value));
        Countly.userData.save();
    },

    clearUser() {
        if (!appKey) return;
        Countly.end_session();
    },
};

export default countly;
